module.exports = __webpack_public_path__ + "static/media/assistant.f1cc8582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/sliderPuzzle/assistant.png
// module id = 521
// module chunks = 0